import { makeStyles } from "@material-ui/core/styles";
import HTMLReactParser from 'html-react-parser';
import "../assets/css/MarkDown.css";
import {Service} from "../service/ServiceApi";

const CustomMarkdown = (props: any) => {

	const classes = useStyles();
	const htmlToReactWithReplace = (content: any) => {
		const replace = (domNode: any) => {
			if (!domNode.attribs) return;

			if (domNode.attribs && domNode.name === 'img') {
				// image on markdown
				if (!String(domNode.attribs.src).includes("http")) {
					return (
						<img style={{ width: "100%",}}  src={`${Service.DOMAIN}${domNode.attribs.src}`} />
					);
				}
			}
		};
		return HTMLReactParser(content, { replace });
	}

	return (
		<div id={"content-markdown"} className={props.className ? props.className : classes.customStyle}>
			{
				props.content && (
					htmlToReactWithReplace(props.content)
				)
			}
		</div>
	);
};

const useStyles = makeStyles((theme) => ({
	root: {
		width: "100%",
		".&p" : {
			padding: 0,
			margin: 0,
			backgroundColor: "red"
		}
	},
	customStyle: {
		textAlign: 'left',
	}
}));

export default CustomMarkdown;
